const mobileMenuLangSwitcherTarget = '.slideout-navigation a.wpml-ls-item-toggle';
jQuery(document).on('ready', function () {
    jQuery(document).on('click', mobileMenuLangSwitcherTarget, function () {
        jQuery(this).siblings('.wpml-ls-sub-menu').slideToggle();
    });
});
